import PageWrapper from "../../common/components/PageWrapper";
import QuizCreate from "../components/QuizCreate";

export default function QuizCreateContainer() {
  return (
    <PageWrapper className="overflow-y-auto">
      <QuizCreate />
    </PageWrapper>
  );
}
